import {encryptRequestObject } from "../adapters/xhr/httpClient";

export async function downloadFile(url, payload, token, onSuccessCallBack, onErrorCallBack) {
    let status = 500;
    let fileName = ''
    const response = await fetch(url,
        {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                'authorization': token
            },
            body: JSON.stringify(await encryptRequestObject(payload))//JSON.stringify(payload)
        }).then(response => {
            status = response.status;
            fileName = response.headers.get('File-Name')
            return response.blob()
        }).then(response => {
            if (status === 200) {
                const type = response.type
                const blob = new Blob([response], { type: type })
                const link = document.createElement('a')
                link.href = window.URL.createObjectURL(blob)
                link.download = fileName
                link.click()
                link.remove()
                if (typeof onSuccessCallBack === 'function') {
                    onSuccessCallBack()
                }

            }
            else {
                if (typeof onErrorCallBack === 'function') {
                    onErrorCallBack()
                }
            }
        })
    return response
}